import { gql } from '@apollo/client';

export const FETCH_OWED_AMOUNT = gql`
  query FetchOwedAmount {
    statistic: getTrustFinancialInfo(trustFinancialInfoInput: {}) {
      otoAmount
    }
  }
`;
